export default {
  computed: {
    columns() {
      return [
        {
          name: 'document_number',
          label: this.$ts('table.th.documentNumber'),
          field: 'document_number',
          sortable: true,
          align: 'left',
          format(value) {
            if (value !== null) {
              return value
            } else {
              return '-'
            }
          },
        },
        {
          name: 'transaction_date',
          label: this.$ts('transactionDate'),
          field: 'transaction_date',
          sortable: true,
          align: 'left',
        },
        {
          name: 'original_cw_id',
          label: this.$ts('table.th.originalSaleSvMonth'),
          field: 'sale_transfer',
          sortable: false,
          align: 'left',
          format: value => {
            return this.$helpers.getValue(value, 'from_cw.cw_name')
          },
        },
        {
          name: 'transferred_member_id',
          label: this.$ts('table.th.transferredToMemberId'),
          field: 'sale_transfer',
          sortable: false,
          align: 'left',
          format: value => {
            return this.$helpers.getValue(value, 'to_user.old_member_id')
          },
        },
        {
          name: 'transferred_member_name',
          label: this.$ts('table.th.transferredToMemberName'),
          field: 'sale_transfer',
          sortable: false,
          align: 'left',
          format: value => {
            return this.$helpers.getValue(value, 'to_user.name')
          },
        },
        {
          name: 'transferred_sv_month',
          label: this.$ts('table.th.transferredToSvMonth'),
          field: 'sale_transfer',
          sortable: false,
          align: 'left',
          format: value => {
            return this.$helpers.getValue(value, 'to_cw.cw_name', '-')
          },
        },
        {
          name: 'created_by',
          label: this.$ts('table.th.createdBy'),
          field: 'sale_transfer',
          sortable: false,
          align: 'left',
          format: value => {
            return this.$helpers.getValue(value, 'created_by.name')
          },
        },
        {
          name: 'created_at',
          label: this.$ts('table.th.createdDateAndTime'),
          field: 'sale_transfer',
          sortable: false,
          align: 'left',
          format: value => {
            return this.$helpers.getValue(value, 'created_at')
          },
        },
      ]
    },
  },
}
